
import { Component, OnInit,} from '@angular/core';


declare const window: any;

@Component({
    selector: 'app-signature',
    templateUrl: './signature.component.html',
    styleUrls: ['./signature.component.scss']
})

export class SignatureComponent implements OnInit {


    public dataUrlImage: any;
    public isHidden = true;
    public drawing = false;
    public mousePos = {
      x: 0,
      y: 0
    };
    public lastPos = this.mousePos;
    public canvas: any;
    public ctx;

    constructor() {

    }


    ngOnInit(): void {
          window.requestAnimFrame = ((callback) => {
                return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                window.msRequestAnimaitonFrame ||
                // tslint:disable-next-line: only-arrow-functions
                function(newcallback): void {
                    window.setTimeout(newcallback, 1000 / 60);
                };
          })();

          const self = this;
          this.canvas = document.getElementById('sig-canvas');
          this.ctx = this.canvas.getContext('2d');
          this.ctx.strokeStyle = '#222222';
          this.ctx.lineWidth = 4;

          this.canvas.addEventListener('mousedown', (e) => {
            this.drawing = true;
            this.lastPos = this.getMousePos(this.canvas, e);
          }, false);

          this.canvas.addEventListener('mouseup', (e) => {
            this.drawing = false;
          }, false);

          this.canvas.addEventListener('mousemove', (e) => {
            this.mousePos = this.getMousePos(this.canvas, e);
          }, false);

          // Add touch event support for mobile
          this.canvas.addEventListener('touchstart', (e) => {

          }, false);

          this.canvas.addEventListener('touchmove', (e) => {
            const touch = e.touches[0];
            const me = new MouseEvent('mousemove', {
              clientX: touch.clientX,
              clientY: touch.clientY
            });
            this.canvas.dispatchEvent(me);
          }, false);

          this.canvas.addEventListener('touchstart', (e) => {
            this.mousePos = this.getTouchPos(this.canvas, e);
            const touch = e.touches[0];
            const me = new MouseEvent('mousedown', {
              clientX: touch.clientX,
              clientY: touch.clientY
            });
            this.canvas.dispatchEvent(me);
          }, false);

          this.canvas.addEventListener('touchend', (e) => {
            const me = new MouseEvent('mouseup', {});
            this.canvas.dispatchEvent(me);
          }, false);

          // Prevent scrolling when touching the canvas
          document.body.addEventListener('touchstart', (e) => {
            if (e.target === this.canvas) {
              e.preventDefault();
            }
          }, false);

          document.body.addEventListener('touchend', (e) => {
            if (e.target === this.canvas) {
              e.preventDefault();
            }
          }, false);

          document.body.addEventListener('touchmove', (e) => {
            if (e.target === this.canvas) {
              e.preventDefault();
            }
          }, false);

          (function drawLoop(): void {
            window.requestAnimFrame(drawLoop);
            self.renderCanvas();
          })();

          // Set up the UI
          const sigText = document.getElementById('sig-dataUrl');
          const sigImage = document.getElementById('sig-image');
          const clearBtn = document.getElementById('sig-clearBtn');
          const submitBtn = document.getElementById('sig-submitBtn');

          clearBtn.addEventListener('click', (e) => {
            self.clearCanvas();
            sigText.innerHTML = 'Data URL for your signature will go here!';
            sigImage.setAttribute('src', '');
          }, false);

          submitBtn.addEventListener('click', (e) => {
            const dataUrl = this.canvas.toDataURL();
            sigText.innerHTML = dataUrl;
            this.isHidden = false;
            sigImage.setAttribute('src', dataUrl);
            sigImage.setAttribute('alt', 'Signed');
          }, false);
    }

    clearCanvas(): void {
        this.canvas.width = this.canvas.width;
      }

     getMousePos(canvasDom, mouseEvent): any {
        const rect = canvasDom.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top
        };
      }

     getTouchPos(canvasDom, touchEvent): any {
        const rect = canvasDom.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top
        };
      }

     renderCanvas(): void {
        if (this.drawing) {
          this.ctx.moveTo(this.lastPos.x, this.lastPos.y);
          this.ctx.lineTo(this.mousePos.x, this.mousePos.y);
          this.ctx.stroke();
          this.lastPos = this.mousePos;
        }
      }

}
